export default __webpack_public_path__ + "media/images/computer-man-3-x-6610332b3b17731945ce7b711b7ac7da.png";